import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

export const TextField = ({ className = '', text }) => {
  const [purify, setPurify] = useState({});

  useEffect(() => {
    import('dompurify').then(DOMPurifyModule => {
      setPurify({ ...DOMPurifyModule.default });
    });
  }, []);

  if (!purify.sanitize) return null;

  return (
    <div
      className={cx('text-field', className)}
      dangerouslySetInnerHTML={{ __html: purify.sanitize(text) }}
    />
  );
};

TextField.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
};
